'use strict';

var InlineBarChartDirective = function InlineBarChartDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/inline-bar-chart.html'),
    controller: 'InlineBarChartController',
    scope: {
      maxValue: '=',
      backBarValue: '=',
      frontBarValue: '=',
      tooltipContent: '='
    },
    link: function link($scope, element) {
      element.popover({
        animation: false,
        content: function content() {
          return $scope.tooltipContent;
        },
        placement: 'top',
        html: true,
        trigger: 'hover'
      });
      function asPercentageStr(fraction) {
        return 100 * fraction + '%';
      }
      $scope.setFrontBarWidth = function (widthFraction) {
        var width = asPercentageStr(widthFraction);
        element.find('.dp-front-bar').css('width', width);
      };
      $scope.setBackBarWidth = function (widthFraction) {
        var width = asPercentageStr(widthFraction);
        element.find('.dp-back-bar').css('width', width);
        element.find('.dp-tile-container .dp-tile-placeholder').css('width', width);
      };
      $scope.$on('$destroy', function () {
        element.popover('destroy');
      });
    }
  };
};
InlineBarChartDirective.$inject = [];
module.exports = InlineBarChartDirective;